import React, { Component } from 'react';
import cx from 'classnames';

class LoadingComponent extends Component {
  static defaultProps = {
    filledWhite: false,
    round: false,
    isVoucher: false,
  }

  shouldComponentUpdate() {
    return false;
  }

  render() {
    const {
      className,
      filledWhite,
      refunds,
      round,
      isGray,
      isVoucher,
      increaseLoaderSize,
    } = this.props;

    const loadingClasses = cx({
      'LoadingComponent': !(className === 'refund-loading' && refunds),
      'LoadingComponent-refund': refunds,
      'LoadingComponent--Details-trip': isGray,
      'LoadingComponent--round': round,
      'LoadingComponent--filledWhite': filledWhite,
      'LoadingComponent--Voucher': isVoucher,
    }, className);

    const loaderClass = cx({
      'LoadingComponent-loader': !refunds,
      'LoadingComponent-loader-refund': refunds,
      'LoadingComponent-loader big-loader': increaseLoaderSize,
    });

    return (
      <div className={ loadingClasses }>
        <div className={ loaderClass }>Loading...</div>
        <div className={ loaderClass }/>
        <div className={ loaderClass }/>
      </div>
    );
  }
}

export default LoadingComponent;
